module.exports = __webpack_public_path__ + "static/media/rhodium-title.797c4480.jpg";